<template>
	<template-base class="containerCard">
		<div>
			<div v-if="contas.length && !showPaginationOnlyFooter" class="head-row mb-2 width-pagination-items">
				<div class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + contas.length }} de {{ pagination.count }}
					</label>
					<b-pagination
						class="mr-0 mb-2"
						id="page"
						v-model="currentPage"
						:total-rows="pagination.count"
						:per-page="pagination.limit.value"
					></b-pagination>
				</div>
				<b-form
					class="text-head-row width-pagination">
					<label class="text-head-row ml-0">
						Itens por página
					</label>
					<b-form-select
						class="mr-0 mb-2"
						v-model="pagination.limit.value"
						name="itens-por-pagina"
						:options="optionsItensPorPag"
						@input="changeItensByPage()"
						:disabled="loading"
					/>
				</b-form>
			</div>
			<EditAccount
				v-if="modalEdit"
				:accountData="accountSelected"
				:isMobile="isMobile"
				@closeModal="closeModal"
				@findAccount="findAccount"
			/>
		</div>
		<div>
			<DataTable v-if="!isMobile"
				class="data-table"
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:nosearch="false"
				:nofilters="true"
				name="contas"
				:hasPagination="true"
				:noedit="true"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_CONTAS')"
				:permissaoDelete="possuiPermissao('GER_D_CONTAS')"
				@clickDelete="confirmaApagar"
				@clickEdit="openEdit"
				@clickSortTableBy="(v) => sortTableBy(v)"
				:state="{
					sortBy: sortTable.sortBy,
					sortAsc: sortTable.order === 1,
					query: ''
				}"
				:async="true"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="openEdit"
				:hideBtnAdd="!possuiPermissao('GER_I_CONTAS')"
			/>
			<CardTransaction v-else
				:loading="loading"
				:colunas="colunas"
				:linhas="linhas"
				:errMsg="errMsg"
				:acoes="true"
				:permissaoEdit="possuiPermissao('GER_U_CONTAS')"
				:permissaoDelete="possuiPermissao('GER_D_CONTAS')"
				@clickDelete="confirmaApagar"
				@clickEdit="openEdit"
				:selectItem="false"
				:globalAcoes="false"
				:colsDataCard="colsDataCard"
				:details="false"
				:showSelectItem="false"
				@state-change="(state) => newSearch(state)"
				@clickBtnAdd="openEdit"
				:nosearch="false"
				:hideBtnAdd="!possuiPermissao('GER_I_CONTAS')"
			/>
		</div>
		<div v-if="contas.length && showPaginationOnlyFooter" class="text-head-row d-block">
			<section style="display: flex; justify-content: center;">
				<b-pagination
					id="page"
					class="mb-1"
					v-model="currentPage"
					:total-rows="pagination.count"
					:per-page="pagination.limit.value"
				></b-pagination>
			</section>
			<section style="display: flex; justify-content: center;">
				<label class="text-head-row" style="width: auto;">
					Resultado {{ pagination.offset + 1 }}-{{ pagination.offset + linhas.length }} de {{ pagination.count }}
				</label>
			</section>
		</div>
	</template-base>
</template>

<script>
	import DataTable from "@/components/DataTable";
	import TemplateBase from "@/templates/Base";

	import { possuiPermissao } from "../../helpers/permissions";
	import { AccountService } from "../../services/account";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import CardTransaction from "@/components/CardTransaction.vue";
	import { mapState } from "vuex";
	import emitter from "@/eventBus.js";
	import EditAccount from "./EditAccount.vue";

	export default {
		components: {
			TemplateBase,
			DataTable,
			CardTransaction,
			EditAccount
		},

		inject: ["parentValidator"],

		data () {
			return {
				modalEdit: false,
				contas: [],
				accountClassOptions: [],
				linhas: [],
				loading: true,
				accountSelected: {},
				accountService: new AccountService(),

				errMsg: "Nenhuma conta cadastrada!",
				colunas: [
					"Conta",
					"Fecha Dia Útil Seg.",
					"Dia Fechamento",
					"Dia Pagamento",
					"Soma Dashboard",
					"Inativa",
					"Tipo de Conta"
				],
				pagination: {
					count: 0,
					page: 1,
					offset: 0,
					limit: {
						value: 50
					},
					pages: 1
				},
				currentPage: 1,
				optionsItensPorPag: [
					{
						value: 5,
						text: "5 Items"
					},
					{
						value: 25,
						text: "25 Items"
					},
					{
						value: 50,
						text: "50 Items"
					},
					{
						value: 75,
						text: "75 Items"
					},
					{
						value: 100,
						text: "100 Items"
					}
				],
				possuiPermissao,
				sortTable: {
					sortBy: 0,
					order: 1,
					query: ""
				},
				isMobile: false,
				colsDataCard: {
					0: {
						idx: 0,
						label: "Conta",
						textAlign: "left",
						cols: 6,
						visible: true
					},
					1: {
						idx: 6,
						label: "Tipo de Conta",
						textAlign: "leftr",
						cols: 6,
						visible: true
					},
					2: {
						idx: 1,
						label: "Fecha Dia Útil Seg.",
						textAlign: "center",
						cols: 4,
						visible: true
					},
					3: {
						idx: 2,
						label: "Dia Fechamento",
						textAlign: "center",
						cols: 4,
						visible: true
					},
					4: {
						idx: 3,
						label: "Dia Pagamento",
						textAlign: "center",
						cols: 4,
						visible: true
					},
					5: {
						idx: null,
						label: "",
						textAlign: "",
						cols: 0,
						visible: false
					},
					6: {
						idx: 4,
						label: "Soma Dashboard",
						textAlign: "center",
						cols: 6,
						visible: true
					},
					7: {
						idx: 5,
						label: "Inativa",
						textAlign: "center",
						cols: 6,
						visible: true
					}
				},
				showPaginationOnlyFooter: true
			};
		},

		computed: {
			...mapState(["accountClass"])
		},

		watch: {
			currentPage () {
				this.changePage(this.currentPage);
			}
		},

		created () {
			this.$validator = this.parentValidator;
		},

		async mounted () {
			this.checkIfMobile();
			window.addEventListener("resize", this.checkIfMobile);

			await this.optionsAccountClass();
			await this.findAccount();
		},

		beforeDestroy () {
			window.removeEventListener("resize", this.checkIfMobile);
		},

		methods: {
			checkIfMobile	() {
				this.isMobile = window.innerWidth <= 768;
			},

			sortTableBy (v) {
				this.sortTable = v;
				this.findAccount();
			},

			changePage () {
				this.pagination.page = this.currentPage;
				this.findAccount();
			},

			changeItensByPage () {
				this.pagination.page = 1;
				this.findAccount();
			},

			async optionsAccountClass () {
				this.accountClassOptions = this.accountClass.reduce((acc, tp) => [
					...acc,
					{
						value: tp.idAccountClass,
						text: tp.description
					}
				], []);
			},

			async findAccount () {
				this.loading = true;
				const limit = this.pagination.limit.value;
				this.pagination.offset = (this.pagination.page - 1) * limit;
				const offset = this.pagination.offset;
				const sortTable = this.sortTable;

				const result = await this.accountService.listAccount({offset, limit, sortTable, inactive: true}) || {};
				this.contas = result.rows || [];

				if (!this.accountClassOptions.length)
					await this.optionsAccountClass();

				this.linhas = result.rows.reduce((acc, c) => [
					...acc,
					{
						idAccount: c.idAccount,
						cols: [
							c.description,
							c.closeNextDayWeekend ? "Sim" : "Não",
							c.closingDay,
							c.payDay,
							c.sumBalanceDashboard ? "Sim" : "Não",
							c.inactive ? "Sim" : "Não",
							(this.accountClassOptions.filter(tc => tc.value === c.idAccountClass))[0].text || ""
						]
					}
				], []);

				this.pagination.count = result.count || 0;
				this.pagination.pages = this.pagination.count > limit ? Math.ceil(this.pagination.count / limit) : 1;
				this.loading = false;
			},

			async openEdit (item_) {
				let item = {};
				if (item_.idAccount)
					[ item ] = this.contas.filter(c => c.idAccount === item_.idAccount);

				this.accountSelected = item;
				this.modalEdit = true;
			},

			async confirmaApagar (item_) {
				const [ item ] = this.contas.filter((gu) => gu.idAccount === item_.idAccount);
				const deleteConfirmation = (await this.$swal({
					title: "Excluir",
					text: "Tem certeza que deseja remover a conta?",
					type: "error",
					showCancelButton: true,
					cancelButtonColor: "#A6A8AB",
					confirmButtonColor: "#DD6B55",
					imageWidth: 50,
					imageHeight: 50,
					cancelButtonText: "Não",
					confirmButtonText: "Sim",
					reverseButtons: true
				})).value;

				if (deleteConfirmation)
					this.apagar(item.idAccount);
			},

			async apagar (idAccount) {
				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Apagando", async () => {
					try {
						await this.accountService.deleteAccount({idAccount});
						this.findAccount();
						emitter.emit("reloadAccount", { reload: true });

						return {
							title: "Sucesso!",
							body: "Conta deletada com sucesso.",
							config
						};
					} catch (error) {
						const msgError = error.response.data.message || "Erro ao tentar deletar a conta!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			newSearch (state) {
				this.sortTable.query = state.query;
				this.findAccount();
			},

			closeModal () {
				this.modalEdit = false;
			}
		}
	};
</script>

<style scoped>
	.toggle-conta {
		/* display: flex; */
		margin-top: 7px;
		/* justify-content: center; */
	}

	label {
		width: 160px;
	}

	.container-head {
		display: flex;
		height: 5rem;
		width: 100%;
	}

	.container-pages {
		display: flex;
		width: 70%;
		margin-top: 1.5rem;
	}

	.containerCard {
		max-width: 90.5%;
	}

	.modal-edicao-label {
		font-family: 'Roboto Condensed Regular';
		font-size: 23px;
	}

	.modal-edicao-input {
		font-family: 'Roboto Condensed Regular';
		font-size: 20px;
	}

	.table-body-detalhe {
		padding: 5px 0;
	}

	.container-add-new-100 {
		width: 100% !important;
	}
</style>
